import axios from "axios";
// import https from "https";

export default axios.create({
  
  // HONBAN
  baseURL: "/comregtaqusu/",
  timeout: 20000,
  // HONBAN
  
  // baseURL: "https://touki-tqs.com/comregtaqusu",
  // timeout: 10000,
  // headers: {'X-Custom-Header': 'foobar'}
  // httpsAgent: new https.Agent({
  //   rejectUnauthorized: false
  //   }),
  // proxy: false,
  // changeOrigin: true,
  // https:false,
});